export const dashboardConstants = {
  GET_DASHBOARD_CSV_REQUEST: "GET_DASHBOARD_CSV_REQUEST",
  GET_DASHBOARD_CSV_SUCCESS: "GET_DASHBOARD_CSV_SUCCESS",
  GET_DASHBOARD_CSV_FAILURE: "GET_DASHBOARD_CSV_FAILURE",
}